export function isValidLPNScan (scanned: string) {
  return /[A-Z]{2,3}-LPN-\d+/.test(scanned)
}
